<template>
  <hr class="my-1" />
</template>
